// extracted by mini-css-extract-plugin
export var externalLink = "_e3-0";
export var internalLinkLabel = "_e3-1";